import React, { useState, useEffect } from "react";

export const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewbox="0 0 48 48" fill="none"><path fill="#519847" fill-rule="evenodd" d="M16.832 19.709c-4.146-1.94-12.66-7.111-13.546-12.268-1.136 4.543.202 10.548 3.265 13.517 2.784 2.698 2.982 4.203 2.982 5.368l-.104-.016c-.577-.088-1.747-.266-2.707-1.461 0 2.641 3.726 10.178 8.292 12.495-.454-.719-.994-2.413-.681-3.833 1.546.815 3.786 2.12 5.667 5.205v-3.248c-.48-.653-1.114-1.306-1.947-1.957-4.175-3.266-4.06-10.423-1.221-13.802Zm12.646 2.657H28v8h-8v.916a6.56 6.56 0 1 1 9.478-8.916Zm-8.117 17h-.985c.32.583.627 1.222.915 1.926.064-.636.102-1.278.07-1.926Zm5.39 0h.985c-.32.583-.626 1.222-.914 1.926a12.887 12.887 0 0 1-.07-1.926Zm12.695-9H37v-8h-4.271c-.344-1.011-.832-1.923-1.448-2.657 4.146-1.94 12.66-7.111 13.546-12.268 1.136 4.543-.203 10.548-3.266 13.517-2.783 2.698-2.982 4.203-2.982 5.368l.104-.016c.578-.088 1.747-.266 2.708-1.461 0 1.17-.732 3.303-1.945 5.517Z" clip-rule="evenodd"></path><path fill="#E5EBEF" fill-rule="evenodd" d="M43 37.366h-8v8h-5v-8h-8v-5h8v-8h5v8h8v5Z" clip-rule="evenodd"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
